import TextField from '@material-ui/core/TextField'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

const styles = (theme) => ({
  root: {},
})

class CustomTextField extends Component {
  constructor(props) {
    super(props)
    this.state = { error: props.error }
  }

  render() {
    const {
      value = '',
      onChange,
      onUpdate,
      settings = {},
      helperText,
      ...rest
    } = this.props
    delete rest.multilang
    const { error } = this.state

    return (
      <TextField
        {...rest}
        {...settings}
        value={value}
        error={this.props.error || error}
        onFocus={this._onFocus}
        onBlur={this._onBlur}
        onChange={this._onChange}
        helperText={helperText}
      />
    )
  }

  _onChange = (e) => {
    const { target = {} } = e
    const { value: originalValue, dataset: { pattern } } = target

    // checks if the pattern allows spaces and replaces them with hyphens
    const patternDisallowsSpaces = pattern && !pattern.includes('s')
    const value = patternDisallowsSpaces
      ? originalValue.replace(/\s+/g, '-')
      : originalValue

    // check validity
    const isValid = new RegExp(pattern).test(value)
    this.setState({ error: !isValid })

    const { onUpdate } = this.props
    onUpdate && onUpdate(value)
  }

  _onFocus = (e) => {
    this.setState({ error: false })

    const { onFocus } = this.props
    onFocus && onFocus(e)
  }

  _onBlur = (e) => {
    try {
      const { value, dataset: { pattern } } = e.target
      const isValid = new RegExp(pattern).test(value)
      this.setState({ error: !isValid })
    } catch (e) {}

    const { onChange } = this.props
    onChange && onChange(e)
  }
}

CustomTextField.propTypes = {
  helperText: PropTypes.string,
}

export default withStyles(styles)(CustomTextField)
